import React from 'react';
import { Create, SimpleForm, BooleanInput, useGetList } from 'react-admin';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomTextField from '../../../ui/custom-text-field';
import CustomSelect from '../../../ui/custom-select';
import { ContentPageSX } from '../../../styled/custom';
import { minLength } from '../../../utils/schemas';

const Schema = Yup.object(
{
  name: minLength(3, "Digite o nome")
});

const normalizeCategoriesMedia = (categoriesMedia) =>
{
  if (!Array.isArray(categoriesMedia))
    return categoriesMedia;

  return categoriesMedia
    .map(categoryMedia => typeof categoryMedia === 'object' && categoryMedia != null ? categoryMedia.id : categoryMedia)
    .filter(categoryMediaId => categoryMediaId !== '' && categoryMediaId != null);
};

const transformTypePlanPayload = (data) =>
{
  return {
    ...data,
    categories_media: normalizeCategoriesMedia(data.categories_media)
  };
};

const TypePlanCreate = () =>
{
  const { data: categoriesMediaData, isLoading: isLoadingCategoriesMedia } =
    useGetList('category-media', { pagination: { page: 1, perPage: 1000000 }});

  return (
    <Create
      title="Novo Tipo de Plano"
      redirect="list"
      transform={transformTypePlanPayload}
      sx={ContentPageSX}>
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}>
        <CustomTextField name="name" label="Nome" fullWidth isRequired />
        <BooleanInput source="has_audio" label="Acesso a Áudio" />
        <BooleanInput source="has_text" label="Acesso a Texto" />
        <BooleanInput source="has_video" label="Acesso a Vídeo" />
        {!isLoadingCategoriesMedia && (
          <CustomSelect
            data={categoriesMediaData}
            name="categories_media"
            label="Categorias de Mídia Incluídas"
            fullWidth />
        )}
      </SimpleForm>
    </Create>
  );
};

export default TypePlanCreate;
